import { VStack, HStack, Text, Divider } from "@chakra-ui/layout";

import { $isnumber, $length, $ok } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";

import { Step } from "./SignupTypes";

interface StepSummaryProps {
    step: Step;
    subscriptionName: Nullable<string>;
    // isAloneUser: Nullable<boolean>;
    // nbCollaborators: number;
    amount: Nullable<number>;
    partnerCode: Nullable<string>;
    tva: Nullable<number>;
    lastname: string;
    firstname: string;
    email: string;
    organizationName: string;
    organizationIdentifier: string;
    organizationIdentifierType: string;
    address: {
        city: string;
        streetNumber?: string;
        street?: string;
        streetComplement?: string;
        zipCode?: string
    };
    tvaIntra: string;
}

export const StepSummary = ({
    step,
    subscriptionName,
    // isAloneUser,
    // nbCollaborators,
    amount,
    tva,
    partnerCode,
    lastname,
    firstname,
    email,
    organizationName,
    organizationIdentifier,
    organizationIdentifierType,
    address,
    tvaIntra,
}: StepSummaryProps) => {
    switch (step) {
        case "subscription":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">{subscriptionName} :</Text>
                        <Text fontWeight="semibold">{amount}€ HT/an</Text>
                    </HStack>
                    {/* {isAloneUser === false && nbCollaborators > 0 && (
                        <HStack>
                            <Text fontWeight="semibold" color="gray.500">Collaborateurs :</Text>
                            <Text>{nbCollaborators} × 60€ HT/an</Text>
                        </HStack>
                    )} */}
                    {$length(partnerCode) > 0 && (
                        <HStack>
                            <Text fontWeight="semibold" color="gray.500">Code partenaire :</Text>
                            <Text>{partnerCode}</Text>
                        </HStack>
                    )}
                    <Divider />
                    <HStack>
                        <Text fontWeight="bold" color="gray.500">Total :</Text>
                        <Text fontWeight="bold" color="green.500">{amount}€ HT/an</Text>
                        {$isnumber(tva) ? 
                            <Text color="gray.500">(TVA: {tva}%, soit {$ok(amount) && $ok(tva) ? (amount! + Math.round(((amount!*tva!/100) + Number.EPSILON) * 100) / 100) : ''}€ TTC/an)</Text>
                            : ''
                        }
                    </HStack>
                </VStack>
            );

        case "account":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Nom :</Text>
                        <Text>{lastname} {firstname}</Text>
                    </HStack>
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Email :</Text>
                        <Text>{email}</Text>
                    </HStack>
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Organisation :</Text>
                        <Text>{organizationName}</Text>
                    </HStack>
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">{organizationIdentifierType} :</Text>
                        <Text>{organizationIdentifier}</Text>
                    </HStack>
                    <HStack alignItems="normal">
                        <Text fontWeight="semibold" color="gray.500">Adresse :</Text>
                        <VStack alignItems="normal">
                            <Text>{address.streetNumber} {address.street}</Text>
                            {$length(address.streetComplement) > 0 && <Text>{address.streetComplement}</Text>}
                            <Text>{address.zipCode} {address.city}</Text>
                        </VStack>
                    </HStack>
                </VStack>
            );

        case "billing":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">TVA intracommunautaire :</Text>
                        <Text>{tvaIntra}</Text>
                    </HStack>
                </VStack>
            );

        default:
            return null;
    }
};